import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *团队分项成绩
 * @param params
 * 
*/

export const teamItemScore = params => Http.get(`${baseUrl}/sz/team/fx/group`, { params })

/**
 *集数列表
 * @param params
 * 
*/

export const episodes = params => Http.get(`${baseUrl}/sz/team/fx/episodes`, { params })

/**
 *视频数据分析
 * @param params
 * 
*/

export const videoAnalysis = params => Http.get(`${baseUrl}/sz/team/fx/episodeVideo`, { params })

/**
 *团队视频数据分析
 * @param params
 * 
*/

export const teamVideoAnalysis = params => Http.get(`${baseUrl}/sz/team/fx/teamVideo`, { params })

/**
 *团队综合成绩
 * @param params
 * 
*/

export const teamScore = params => Http.get(`${baseUrl}/sz/team/fx/totalScore`, { params })
